import Repository from '@/libs/axios'

const resource = '/superadmin/resource'

export default {
  getOrderStatusList() {
    return Repository.get(`${resource}/order-status-list`)
  },
}
